<template>

    <div class="c-alert" :class="getClasses">
        <p class="c-alert__title">{{ alert.title }}</p>
        <p class="c-alert__content" v-html="alert.body"></p>
        <button class="c-alert__close" @click="close"></button>
    </div>

</template>


<script>

export default {

    name: 'AlertsItem',

    props: {
        alert: Object
    },

    data() {
        return {
            fadeIn1: false,
            fadeIn2: false,
            fadeOut: false
        }
    },

    computed: {
        getClasses() {
            return {
                'fadeIn1': this.fadeIn1,
                'fadeIn2': this.fadeIn2,
                'fadeOut': this.fadeOut,
                ['c-alert--' + this.alert.type]: this.alert.type
            }
        }
    },

    methods: {
        closeAlert() {
            this.fadeOut = true
            setTimeout(() => {
                this.$store.dispatch('REMOVE_ALERT', this.alert.id)
            }, 500)
        },
        close() {
            clearTimeout(this.timer)
            this.closeAlert()
        }
    },

    mounted() {
        setTimeout(() => {
            this.fadeIn1 = true
        }, 50)
        setTimeout(() => {
            this.fadeIn2 = true
        }, 300)
        this.timer = setTimeout(this.closeAlert, this.alert.timeout)
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-alert {
    position: relative;
    width: 100%;
    padding: 0 1rem 0 3.6rem;
    transform: translate3d(100%, 0, 0);
    opacity: 0;
    color: $c-white;
    border-radius: 0.25rem;
    background-size: 1.1rem 1.1rem;
    background-repeat: no-repeat;
    background-position: 1rem 1.2rem;
    margin-bottom: 0;
    height: 0;
    overflow: hidden;
    pointer-events: auto;
    box-shadow: 5px 5px 30px $c-shadow;
    transition-property: opacity, transform, height;
    transition-duration: .3s;
    transition-timing-function: cubic-bezier(0, .3, .3, 1);

    &--info {
        background-color: $c-info;
        background-image: url('#{$icons}/info.svg');
    }
    &--warning {
        background-color: $c-warning;
        background-image: url('#{$icons}/warning.svg');
    }
    &--error {
        background-color: $c-error;
        background-image: url('#{$icons}/error.svg');
    }
    &--success {
        background-color: $c-success;
        background-image: url('#{$icons}/ok.svg');
    }
    &__title {
        font-weight: bold;
        margin: 0;
        line-height: 1.25rem;
        max-height: 1.25rem;
        margin-top: 1rem;
    }
    &.fadeIn1 {
        margin-bottom: 5px;
        height: 81px;
    }
    &.fadeIn2 {
        transform: translate3d(0%, 0, 0);
        opacity: 1;
    }
    &.fadeOut {
        animation: alert-fadeOut .6s ease-in-out;
        animation-fill-mode: forwards;

        @keyframes alert-fadeOut {
            50% {
                opacity: 0;
                transform: translate3d(100%, 0, 0);
                height: 81px;
                margin-bottom: 5px;
            }
            100% {
                opacity: 0;
                transform: translate3d(100%, 0, 0);
                margin-bottom: 0;
                height: 0;
            }
        }
    }
    &__content {
        overflow: hidden;
        line-height: 1.25em;
        max-height: 2.5em;
        word-wrap: break-word;
        margin-bottom: 1rem;
    }
    &__close {
        position: absolute;
        top: 6px;
        right: 6px;
        width: 10px;
        height: 10px;
        border: 0;
        background-color: transparent;
        background-image: url('#{$icons}/close.svg');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        cursor: pointer;
    }
}

</style>
